import { PLATFORM_WEBSITE_URL } from './constants/platform';

const learnMoreLinks = {
  schOverview:
    'https://support.brandlive.com/hc/en-us/articles/40620823020571-What-is-Snackable-Content-Hub',
  eventListing:
    'https://support.brandlive.com/hc/en-us/sections/40520872060443-Create-Event',
  eventOverview:
    'https://support.brandlive.com/hc/en-us/articles/40620896872475-What-is-Event-Overview',

  sessionPage: 'https://support.brandlive.com/hc/en-us/sections/40520873176219-Create-Sessions',
  sessionAdvanceChatLink:
    'https://support.brandlive.com/hc/en-us/articles/40620876845083-Engagement-Options-What-is-the-Chat-option-in-a-session-How-to-enable-it-for-a-session',
  sessionAdvanceQALink:
    'https://support.brandlive.com/hc/en-us/articles/40620890774299-Engagement-Options-How-to-enable-Q-A-in-a-session',
  sessionAdvancePollLink:
    'https://support.brandlive.com/hc/en-us/articles/40620905477915-Engagement-Options-What-are-Polls-in-a-session',
  sessionAttendeeListLink:
    'https://support.brandlive.com/hc/en-us/articles/40620913354907-Engagement-Options-How-to-enable-attendees-to-see-other-attendees-during-the-session',
  sessionUpcomingsessionLink:
    'https://support.brandlive.com/hc/en-us/articles/40620902629787-How-to-enable-Attendees-to-see-the-upcoming-agenda-and-switch-to-other-Sessions',
  sessionAdvanceInterprefyTokenLink:
    'https://support.brandlive.com/hc/en-us/articles/40620841354011-Advance-Settings-How-to-set-up-an-Interprefy-interpretation-service-for-a-session',

  ticketsAddLink: '#',
  ticketsConnectStripe: '#',
  ticketsWidget:
    'https://support.brandlive.com/hc/en-us/articles/40620918198043-Embed-Registration-Ticket-Widget',

  advanceSessionWaitListLink:
    'https://support.brandlive.com/hc/en-us/articles/40620930309787-How-to-approve-attendee-s-sessions-registrations-which-are-on-the-Waitlist',
  advanceSessionVisibilityLink:
    'https://support.brandlive.com/hc/en-us/articles/40620921105947-What-is-Session-visibility',
  advanceSessionRegistrationLink:
    'https://support.brandlive.com/hc/en-us/articles/40620868614683-What-is-Session-Registration',

  sessionStreamYoutubeLink:
    'https://support.brandlive.com/hc/en-us/articles/40620849051803-How-to-add-YouTube-as-a-streaming-source',
  sessionStreamVimeoLink:
    'https://support.brandlive.com/hc/en-us/articles/40620870738075-How-to-add-Vimeo-as-a-streaming-source',
  sessionStreamZoomLink:
    'https://support.brandlive.com/hc/en-us/articles/40620857223067-Zoom-Webinar-How-to-add-Zoom-Webinar-as-a-streaming-source',
  sessionStreamCustomLink:
    'https://support.brandlive.com/hc/en-us/articles/40620871938075-How-to-add-Virtual-Pro-Streaming-as-a-streaming-source',
  sessionStreamOtherLink:
    'https://support.brandlive.com/hc/en-us/articles/40620856003099-Custom-Other-How-to-add-Other-live-streaming-as-a-stream-source',
  sessionStreamIBMLink:
    'https://support.brandlive.com/hc/en-us/articles/40620827477403-IBM-How-to-add-IBM-Watson-as-a-streaming-source',
  sessionStreamFBLink:
    'https://support.brandlive.com/hc/en-us/articles/40620857279643-Custom-Other-How-to-add-Facebook-Player-as-a-streaming-source',
  sessionStreamPreRecordedLink:
    'https://support.brandlive.com/hc/en-us/articles/40620843591195-Pre-recorded-How-to-add-pre-recorded-video-as-a-stream-source',
  sessionStudioHostLink:
    'https://support.brandlive.com/hc/en-us/articles/40620867695259-Host-Guide-For-The-Webinar-Broadcasting-Studio',
  sessionStudioHostURLLink:
    'https://support.brandlive.com/hc/en-us/articles/40620826451739-Virtual-Pro-Broadcasting-Studio-What-is-a-Studio-Link',

  peoplePage: 'https://support.brandlive.com/hc/en-us/sections/40520874983835-All-about-People',
  virtualBoothPage:
    'https://support.brandlive.com/hc/en-us/articles/40620848827931-What-is-a-Virtual-Booth',
  virtualBoothFeatureBoothLink:
    'https://support.brandlive.com/hc/en-us/articles/40620920028955-How-to-feature-the-virtual-booth',
  virtualBoothListingBanner:
    'https://support.brandlive.com/hc/en-us/articles/40620880248091-What-is-a-Listing-Page-Banner-How-to-upload-a-Listing-Page-Banner',
  virtualBootSmallBanner:
    'https://support.brandlive.com/hc/en-us/articles/40620897410075-How-to-Add-Small-Banner',
  virtualBoothSpotlightBanner:
    'https://support.brandlive.com/hc/en-us/articles/40620898895003-What-is-a-spotlight-banner-How-to-upload-a-spotlight-banner',
  virtualBoothCustomCTALink:
    'https://support.brandlive.com/hc/en-us/articles/40620890684571-How-to-create-custom-CTA-on-Virtual-Booths-so-attendees-can-engage-with-the-Virtual-Booth',
  virtualBoothPremiumBooths:
    'https://support.brandlive.com/hc/en-us/sections/40520903964443-Setup-booths',
  virtualBoothExport:
    'https://support.brandlive.com/hc/en-us/articles/40620871901979-How-to-add-Virtual-Booths-for-the-event',

  meetingsPage: 'https://support.brandlive.com/hc/en-us/sections/40520891575067-One-to-One-Meetings',
  loungePage: 'https://support.brandlive.com/hc/en-us/sections/40520858876187-Networking-Lounges',

  roomsPage: 'https://support.brandlive.com/hc/en-us/sections/40520875833883-Manage-Rooms',
  roomInfo:
    'https://support.brandlive.com/hc/en-us',
  roomsFilterWocanJoin:
    'https://support.brandlive.com/hc/en-us/articles/40620904053147-What-is-the-Who-Can-Join-The-Room-option-in-Rooms',
  roomsFilterWocanShare:
    'https://support.brandlive.com/hc/en-us/articles/40620871595547-What-is-Who-Can-Share-Audio-Video-In-The-Room-in-the-Rooms',

  engagementNotificationPage:
    'https://support.brandlive.com/hc/en-us/articles/40620835160219-Activity-Feed-and-Notifications-What-are-notifications-How-to-create-a-new-notification',
  engagementActivityPage:
    'https://support.brandlive.com/hc/en-us/articles/40620848730651-Activity-Feed-and-Notifications-What-is-the-purpose-of-the-activity-feed',
  engagementLeaderBoardPage:
    'https://support.brandlive.com/hc/en-us/articles/40620827224475-Leaderboard-What-is-a-leaderboard',
  brandEventPage: 'https://support.brandlive.com/hc/en-us/sections/40520905225243-Branding',
  brandEventCommBannerLink:
    'https://support.brandlive.com/hc/en-us/articles/40620873327387-What-are-community-banners',
  brandEventEventLogoLink:
    'https://support.brandlive.com/hc/en-us/articles/40620906494235-What-are-the-event-logos-Where-are-they-displayed',
  brandEventLoginBannerLink:
    'https://support.brandlive.com/hc/en-us/articles/40620886424091-What-are-the-login-banners',
  brandEventWelcomeLink:
    'https://support.brandlive.com/hc/en-us/articles/40620885797019-What-is-a-Welcome-Video-and-How-do-you-configure-it',
  brandHideHubiloLink:
    'https://support.brandlive.com/hc/en-us/articles/40620895507355-How-to-brand-your-event',
  brandEventColorsLink:
    'https://support.brandlive.com/hc/en-us/articles/40620888928283-How-to-add-theme-colour-to-the-event',
  brandEventCustomTheme:
    'https://support.brandlive.com/hc/en-us/articles/40620877294875-How-to-add-a-custom-theme-to-your-event-in-the-New-Community',
  brandEventCoverImages:
    'https://support.brandlive.com/hc/en-us/articles/40620887036571-How-to-Add-a-Cover-Image',

  analyticsPage: 'https://support.brandlive.com/hc/en-us/sections/40520891936923-Analytics',
  recordingPage:
    'https://support.brandlive.com/hc/en-us/articles/40620843203355-What-is-the-Recordings-section',
  filelogPage:
    'https://support.brandlive.com/hc/en-us/articles/40620840982427-What-is-file-logs-on-Virtual-Pro',

  settingPage: '',
  settingLoginoptions:
    'https://support.brandlive.com/hc/en-us/articles/40620931426715-Understand-your-event-app-s-Login-Settings',
  settingGeneral:
    'https://support.brandlive.com/hc/en-us/articles/40620872598427-General-Settings-on-the-Community',
  settingEventSection:
    'https://support.brandlive.com/hc/en-us/articles/40620892155803-What-is-the-event-section-and-How-to-configure-set-up-visibility-for-different-groups',
  settingEventSectionTopNav:
    'https://support.brandlive.com/hc/en-us/articles/40620921808539-How-to-move-sections-between-the-top-and-side-panels',
  settingGroups:
    'https://support.brandlive.com/hc/en-us/articles/40620907460891-How-to-add-a-group-How-to-set-chat-and-meeting-permissions-for-a-group',
  settingProfileField:
    'https://support.brandlive.com/hc/en-us/articles/40620891947035-What-are-custom-profile-fields-How-to-add-custom-profile-fields-to-the-event',
  settingMatchMaking:
    'https://support.brandlive.com/hc/en-us/articles/40620917279003-What-is-matchmaking-How-to-create-matchmaking-fields',
  settingSenderDetail:
    'https://support.brandlive.com/hc/en-us/articles/40620891406235-What-are-Sender-Details-and-how-is-it-useful',
  settingInviteMailer:
    'https://support.brandlive.com/hc/en-us/articles/40620929173019-What-is-an-invite-mailer-How-to-configure-the-invite-mailer',
  settingLegal:
    'https://support.brandlive.com/hc/en-us/articles/40620902073627-In-legal-settings-how-to-configure-the-labels-descriptions-and-links-for-your-Terms-Conditions-Privacy-Policies-and-Cookie-Policy',
  settingPrivacy:
    'https://support.brandlive.com/hc/en-us/articles/40620876536347-What-is-GDPR-Compliant-How-to-configure-privacy-details',
  settingUserConsent:
    'https://support.brandlive.com/hc/en-us/articles/40620901185307-How-to-set-the-user-consent-for-first-time-users-while-Signup-Login',

  settingSEO:
    'https://support.brandlive.com/hc/en-us/articles/40620852250907-What-is-SEO-and-How-to-configure-it',
  settingSEOConfigure:
    'https://support.brandlive.com/hc/en-us/articles/40620852250907-What-is-SEO-and-How-to-configure-it',
  settingNotification:
    'https://support.brandlive.com/hc/en-us/articles/40620886406299-How-to-configure-notifications-for-the-event-triggers-on-email-and-in-app',
  settingIntegration:
    'https://support.brandlive.com/hc/en-us/articles/40620888341403-How-to-add-custom-code',
  settingCustomintegration:
    'https://support.brandlive.com/hc/en-us/articles/40620888341403-How-to-add-custom-code',
  settingZoomintegration:
    'https://support.brandlive.com/hc/en-us/articles/40620823385115-Advance-Settings-Integrate-Your-Zoom-Account-with-Virtual-Pro',
  settingStudioHosts:
    'https://support.brandlive.com/hc/en-us/articles/40620863521179-Virtual-Pro-Broadcasting-Studio-What-is-the-Studio-Host-option-in-the-Event-Settings',

  ticketPage: 'https://support.brandlive.com/hc/en-us/sections/40520873802779-Setup-registration',
  stripeConnect:
    'https://support.brandlive.com/hc/en-us/articles/40620868658075-Connect-your-Stripe-account-on-Virtual-Pro-to-sell-paid-tickets',
  orderPage:
    'https://support.brandlive.com/hc/en-us/articles/40620929789083-How-to-track-the-purchase-orders',
  surveyPage:
    'https://support.brandlive.com/hc/en-us/articles/40620825312283-Survey-How-to-Create-a-Survey-What-are-the-different-types-of-Surveys',
  sponsor:
    'https://support.brandlive.com/hc/en-us/articles/40620827042459-Sponsored-Ads-What-are-Sponsored-Ads-How-to-add-your-creatives-to-the-Ad-space',

  contestPage:
    'https://support.brandlive.com/hc/en-us/articles/40620848630811-Contest-What-is-a-Contest-and-how-many-types-of-contests-are-there',
  entriesContestHome: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  entriesContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  moderateContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  responseContestHome: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',

  winnerContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  responseContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  questionContestHome: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  standingContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',
  quizContest: 'https://support.brandlive.com/hc/en-us/sections/40520905058971-Engagement',

  creditUsage: 'https://support.brandlive.com/hc/en-us/articles/40620810675867',
  configureCreditType:
    'https://support.brandlive.com/hc/en-us/articles/40620863610779-Advance-Settings-What-is-CPE-Continuous-Professional-Education-Credit-How-to-create-credit-type-and-certificate',
  creditTypeAndCertificate:
    'https://support.brandlive.com/hc/en-us/articles/40620863610779-Advance-Settings-What-is-CPE-Continuous-Professional-Education-Credit-How-to-create-credit-type-and-certificate',
  planUpgradation: 'https://support.brandlive.com/hc/en-us/articles/40620810675867',
  peopleCredits: 'https://support.brandlive.com/hc/en-us/articles/40620810675867',
  boothCredits: 'https://support.brandlive.com/hc/en-us/articles/40620810675867',

  contactsPage:
    'https://support.brandlive.com/hc/en-us',
  multiEventAnalytics:
    'https://support.brandlive.com/hc/en-us/articles/40620902787867-What-does-Multi-Event-Analytics-contain',
  advanceSessionCustomIframe:
    'https://support.brandlive.com/hc/en-us/articles/40620879018267-How-to-set-up-custom-iframe-integrations-in-sessions',

  upgradePlan: `${PLATFORM_WEBSITE_URL}/platform-preview/`,
  // v2 Links
  v2Links: {
    orderPage:
      'https://support.brandlive.com/hc/en-us/articles/40620889390235-What-are-orders-in-Registration',
    discountPage:
      'https://support.brandlive.com/hc/en-us/articles/40620906274203-How-to-set-up-Discounts-for-Paid-Tickets',
    ticketSettings: {
      taxSetting:
        'https://support.brandlive.com/hc/en-us/articles/40620907514651-Configure-tax-invoice-settings-for-your-ticket-registrations',
      buyerForm:
        'https://support.brandlive.com/hc/en-us/articles/40620917532443-What-is-the-Buyer-form-in-the-Ticket-setting',
      enableSimpleRegistration:
        'https://support.brandlive.com/hc/en-us/articles/40620931403163-Enable-Simple-Registration',
      otherPaymentMethod:
        'https://support.brandlive.com/hc/en-us/articles/40620931074587-Various-payment-methods-available-for-buying-tickets-for-events',
      newOtherPaymentMethod:
        'https://support.brandlive.com/hc/en-us/articles/40620882413979-Other-Payment-Method-Flow-Ticket-setup-Order-status-and-Pay-at-the-Venue',
    },
    ticket: {
      main: 'https://support.brandlive.com/hc/en-us/articles/40620867964315-How-to-create-new-tickets',
      basicDetails:
        'https://support.brandlive.com/hc/en-us/articles/40620875173531-What-are-Basic-Details-in-Add-Edit-Ticket-in-Hubilo-Event',
      customizeDetails:
        'https://support.brandlive.com/hc/en-us/articles/40620875173531-What-are-Basic-Details-in-Add-Edit-Ticket-in-Hubilo-Event',
      stripeBillingLink:
        'https://support.brandlive.com/hc/en-us/articles/40620868658075-Connect-your-Stripe-account-on-Virtual-Pro-to-sell-paid-tickets',
    },
  },
  session_engagement_section:
    'https://support.brandlive.com/hc/en-us/articles/40620891296539-Engagement-Options-What-are-the-engagement-options-during-the-session',
  MultiLingualSupport:
    'https://support.brandlive.com/hc/en-us/articles/40620938689563-Selecting-Time-Zone-and-Language-for-Multilingual-Event',
  MultiLingualSupport1:
    'https://support.brandlive.com/hc/en-us/articles/40620937917339-How-to-host-a-Multilingual-event',
  closeCaptionInSession:
    'https://support.brandlive.com/hc/en-us/articles/40620860337051-Closed-Captioning-in-your-Live-sessions-with-Virtual-Pro-Streaming',
  simulcast_this_sesssion:
    'https://support.brandlive.com/hc/en-us/articles/40620835739291-Custom-Other-Simulcast-Your-Live-Session',
  advance_meeting_link:
    'https://support.brandlive.com/hc/en-us/articles/40620870569883-How-to-configure-meeting-visibility-and-settings',

  setting_flx_event_section_1:
    'https://support.brandlive.com/hc/en-us/articles/40620892155803-What-is-the-event-section-and-How-to-configure-set-up-visibility-for-different-groups',
  setting_flx_event_section_2:
    'https://support.brandlive.com/hc/en-us/articles/40620921808539-How-to-move-sections-between-the-top-and-side-panels',
  setup_restricted_event:
    'https://support.brandlive.com/hc/en-us/articles/40620931532443-How-to-set-up-log-in-process-for-a-restricted-event',
  custom_login_code:
    'https://support.brandlive.com/hc/en-us/articles/40620918263195-How-to-set-up-a-custom-login-code',
  virtual_background_link: 'https://support.brandlive.com/hc/en-us/articles/40620844256283',
  interactive_live_session_poll:
    'https://support.brandlive.com/hc/en-us/articles/40620907068315-Engagement-Options-Interactive-Live-Session-Polls',
  interactive_live_session_chat:
    'https://support.brandlive.com/hc/en-us/articles/40620920671003-Engagement-Options-Interactive-Live-Session-Chats',
  interactive_live_session_qna:
    'https://support.brandlive.com/hc/en-us/articles/40620891872283-Engagement-Options-Interactive-Live-Session-Q-A',
  ticket_tracking:
    'https://support.brandlive.com/hc/en-us/articles/40620918027035-Add-tracking-pixel-to-event-landing-page-ticketing-page',
  iframe_learn_more:
    'https://support.brandlive.com/hc/en-us/articles/40620888386331-Embeddable-event-section-widgets-on-the-dashboard',

  roomAdvanceChatLink:
    'https://support.brandlive.com/hc/en-us/articles/40620916891931-What-is-the-Live-Chat-feature-in-Rooms-How-to-enable-it',
  roomAdvanceQALink:
    'https://support.brandlive.com/hc/en-us/articles/40620917318171-What-is-a-Q-A-feature-in-Rooms-How-to-enable-it',
  roomAdvancePollLink:
    'https://support.brandlive.com/hc/en-us/articles/40620920562715-What-are-Live-Polls-Feature-in-Rooms-and-how-to-enable-it',
  roomAttendeeListLink:
    'https://support.brandlive.com/hc/en-us/articles/40620916452251-What-are-the-engagement-options-in-Rooms',

  eventLandingPage:
    'https://support.brandlive.com/hc/en-us/articles/40620843828123-Landing-Page-Builder-Event-Landing-Page-Overview',
  defaultLandingPage:
    'https://support.brandlive.com/hc/en-us/articles/40620869877403-Landing-Page-Builder-Event-Landing-Page-Default-Setup',
  customLandingPage:
    'https://support.brandlive.com/hc/en-us/articles/40620826696347-Landing-Page-Builder-Landing-Page-Builder-Create-Your-Own-Landing-Page',
  newCustomDLP:
    'https://support.brandlive.com/hc/en-us/sections/40520897341595-Creating-a-Custom-Event-Landing-Page',
  mentionsLearMoreLink:
    'https://support.brandlive.com/hc/en-us/articles/40620921904539-Mention-users-or-various-sections-on-the-event-platform',
  backgroundModeLearnMoreLink:
    'https://support.brandlive.com/hc/en-us/articles/40620851244571-How-to-manage-embedded-apps-for-each-session-in-an-event',
  termsAndConditions: 'https://www.brandlive.com/legal',
  privacyPolicy: `${PLATFORM_WEBSITE_URL}/privacy-policy`,
  setUpSSO: 'https://support.brandlive.com/hc/en-us/articles/40620877344795-SSO-How-to-set-up-SSO',
  emailManager: 'https://support.brandlive.com/hc/en-us/sections/40520889361691-Email-Manager',
  sessionEnhanceLayout: 'https://support.brandlive.com/hc/en-us/articles/40620907866139',
  sessionBGImage: 'https://support.brandlive.com/hc/en-us/articles/40620844256283',
  copyYourExistingEvent:
    'https://support.brandlive.com/hc/en-us/articles/40620885567515-Copy-your-existing-event',
  checkInForSessionOnSiteAttendees: 'https://support.brandlive.com/hc/en-us/articles/40620840417947',
  manageReports:
    'https://support.brandlive.com/hc/en-us/articles/40620824076699-Manage-Analytics-Report',
  creditsInSessions: 'https://support.brandlive.com/hc/en-us/articles/40620810570011',
  rtmpAndStreamKey:
    'https://support.brandlive.com/hc/en-us/articles/40620835663131-Custom-Other-What-is-RTMP-Stream-Key',
  copyEventWebinar: `${PLATFORM_WEBSITE_URL}/`, // [TO DO] : This needs to be updated with learn more link for webinar copy events.
  downloadReportInfo: `${PLATFORM_WEBSITE_URL}/`,

  webinarRegistrationForm:
    'https://support.brandlive.com/hc/en-us/articles/40620851095067-Setup-registration-form-for-the-webinar',
  enableSimpleRegistration:
    'https://support.brandlive.com/hc/en-us/articles/40620931403163-Enable-Simple-Registration',
  BuyerFormInTicket:
    'https://support.brandlive.com/hc/en-us/articles/40620917532443-What-is-the-Buyer-form-in-the-Ticket-setting',
  QuizPage: 'https://support.brandlive.com/hc/en-us/articles/40620833461019',
  activityScoreBoardUrl:
    'https://support.brandlive.com/hc/en-us/articles/40620833550235-Lead-Score-Introduction-to-the-feature',
  leadScoreBoardUrl:
    'https://support.brandlive.com/hc/en-us/articles/40620895360539-Activity-scoring-Lead-Score',
  leadLevelBoardUrl:
    'https://support.brandlive.com/hc/en-us/articles/40620896313243-Lead-levels-Lead-Scoring',
  leadScoreAnalytics:
    'https://support.brandlive.com/hc/en-us/articles/40620852176795-Analytics-and-Reports-Lead-scoring',
  hubspotSetup: 'https://support.brandlive.com/hc/en-us/articles/40620845653019-Hubspot-1-Setup',
  importDataFromHubSpot:
    'https://support.brandlive.com/hc/en-us/articles/40620860088859-Hubspot-5-Import-data-from-HubSpot-to-Webinar',
  exportDataFromHubSpot:
    'https://support.brandlive.com/hc/en-us/articles/40620872491547-Hubspot-3-Export-data-from-Webinar-to-HubSpot',
  exportUserActivitiesHubSpot:
    'https://support.brandlive.com/hc/en-us/articles/40620879524507-Hubspot-4-Export-User-Activities-from-Webinar-to-HubSpot',
  hubspotContactProperty:
    'https://support.brandlive.com/hc/en-us/articles/40620895371035-Hubspot-2-Contact-Property-Creation',
  hubiloPeopleAnalytics:
    'https://support.brandlive.com/hc/en-us/articles/40620840729115-Summary-of-People-Analytics-view-in-Hubilo-dashboard',
  embeddedApp: 'https://support.brandlive.com/hc/en-us/sections/40520914664347-Embedded-Apps',
  manageEmbeddedAppEventLevel:
    'https://support.brandlive.com/hc/en-us/articles/40620865184923-How-to-manage-embedded-apps-at-the-Event-Level',
  zoomIntegrationlink:
    'https://support.brandlive.com/hc/en-us/articles/40620823385115-Advance-Settings-Integrate-Your-Zoom-Account-with-Virtual-Pro',
  salesforceSetup:
    'https://support.brandlive.com/hc/en-us/articles/40620849487899-Salesforce-How-to-set-up-and-enable-the-Salesforce-Integration-for-your-Webinar-event',
  configureSalesforceCampaign:
    'https://help.salesforce.com/s/articleView?id=sf.create_a_campaign.htm&type=5',
  campaignSourceData:
    'https://thespotforpardot.com/2020/12/04/how-to-add-custom-fields-to-campaign-members-in-salesforce/#:~:text=You%20can%20add%20the%20new,icon%20to%20select%20your%20fields.',
  configureSFCampaign:
    'https://support.brandlive.com/hc/en-us/articles/40620872417819-Salesforce-How-to-connect-Salesforce-Campaign-with-your-Webinar-event',
  configureSFMemberStatus:
    'https://help.salesforce.com/s/articleView?id=sf.campaigns_customize_member_status_parent.htm&type=5',
  configureNotAttendedStatus:
    'https://support.brandlive.com/hc/en-us/articles/40620872417819-Salesforce-How-to-connect-Salesforce-Campaign-with-your-Webinar-event',
  UTMLink: 'https://support.brandlive.com/hc/en-us/articles/40620823505179-UTM-code-Mapping',
  emailFiltering: 'https://support.brandlive.com/hc/en-us/articles/40620921969563',
  createActivityTypeInSalesforce:
    'https://experienceleague.adobe.com/docs/marketo/using/product-docs/marketo-sales-connect/crm/salesforce-customization/activity-type-field-on-tasks-sfdc.html?lang=en',
  slackbotBrowsePeople:
    'https://slack.com/intl/en-in/help/articles/360003534892-Browse-people-and-user-groups-in-Slack',
  slackbotAddApp:
    'https://slack.com/intl/en-in/help/articles/202035138-Add-apps-to-your-Slack-workspace#request-app-approval',
  setupMarketo: 'https://support.brandlive.com/hc/en-us/articles/40620845061531-Marketo-1-Marketo-Integration-Guide',
  marketoCustomActivity:
    'https://support.brandlive.com/hc/en-us/articles/40620873795355-Marketo-5-Configure-Attendee-s-Activity-as-Custom-Activities',
  marketoConnectProgram:
    'https://support.brandlive.com/hc/en-us/articles/40620864832027-Marketo-2-Configuring-Marketo-Program-with-Webinar-Webinar-Event',
  marketoCreateGroupId:
    'https://support.brandlive.com/hc/en-us/articles/40620866310811-Marketo-3-Import-data-from-Marketo-to-Webinar',
  salesforceSetupActivities:
    'https://support.brandlive.com/hc/en-us/articles/40620873775387-Salesforce-How-to-export-Attendee-activities-from-Webinar-to-Salesforce',
  overviewVideoSnippetBanner:
    'https://support.brandlive.com/hc/en-us/articles/40620843203355-What-is-the-Recordings-section-',
  hubspotConfigureImport: 'https://knowledge.hubspot.com/workflows/create-workflows',
  hubspotLoginPage: 'https://app.hubspot.com/myaccounts-beta',
  setupPardot: 'https://support.brandlive.com/hc/en-us/articles/40620864812315',
  pardotConnectProgram: 'https://support.brandlive.com/hc/en-us/articles/40620850690971',
  pardotCreateMaketingApp: 'https://support.brandlive.com/hc/en-us/articles/40620852020635',
  pardotAttendeeActivity: 'https://support.brandlive.com/hc/en-us/articles/40620852020635',
  paradotSalesforceGuide:
    'https://help.salesforce.com/s/articleView?language=en_US&id=user_security_token.htm&type=5',
  mediaPlusHubspotIntegration:
    'https://support.brandlive.com/hc/en-us/sections/40520904139291-Integrating-Media-with-Lead-Forms',
  viewDocumentLink: 'https://support.brandlive.com/hc/en-us/sections/40520898145819-Integrations',
  msDynamicsCRM: 'https://support.brandlive.com/hc/en-us/articles/40620809642651-Microsoft-Dynamics-365-Export-your-Webinar-registrations-to-MS-Dynamics-CRM'
};

export default learnMoreLinks;
